module.exports = __webpack_public_path__ + "img/server.b630fc43.png";